import {
  AUTOMATION_STATUSES,
  CONTACT_TYPE,
  RECOGNITION_STATUSES,
  SOURCE_TYPES
} from '@hero/constants';

const isDraftOrReadyToSend = status =>
  status === RECOGNITION_STATUSES.draft || status === RECOGNITION_STATUSES.readyToSend;
const isLive = status => status === RECOGNITION_STATUSES.live;
const isActive = status => status === AUTOMATION_STATUSES.active;
const isExpired = status => status === RECOGNITION_STATUSES.expired;
const isDeactivate = status => status === AUTOMATION_STATUSES.deactivated;
const isApprovalPending = status => status === RECOGNITION_STATUSES.pending_approval;
const isContactLess = feature => feature?.contacts?.type === CONTACT_TYPE.number;
const isTeams = feature => feature?.source === SOURCE_TYPES.teams_app;

export {
  isActive,
  isApprovalPending,
  isContactLess,
  isDeactivate,
  isDraftOrReadyToSend,
  isExpired,
  isLive,
  isTeams
};
